<agr-page-toolbar [pageTitle]="pageTitle$ | async" [hasPrimaryAction]="false" class="milk-delivery">
  <div class="wrapper--spacing-all">
    <div class="flex--justify-space-between spacing--margin-bottom">
      <h5 class="text--h5">{{ 'dairyresults.milk-delivery.header' | translate }}</h5>
      <agr-daterange-picker
        [config]="customDateRangeConfig"
        (change)="onDateRangeChanged($event)"
      ></agr-daterange-picker>
    </div>
    <div class="spacing--margin-bottom table-desktop">
      @if (this.initTable()) {
        <table
          mat-table
          matSort
          #table
          [dataSource]="dataSource"
          class="table-desktop__table--alternate-rows cust-table"
        >
          @for (column of columnIds(); track column; let colIndex = $index) {
            <ng-container matColumnDef="{{ column }}">
              <th
                mat-header-cell
                mat-sort-header
                *matHeaderCellDef
                [class]="{ 'text--right': allignRight(columns[colIndex].type) }"
              >
                @if (columns[colIndex].subLabel) {
                  <div>
                    <div class="flex--column">
                      <div>
                        {{ columns[colIndex].label | translate }}
                      </div>
                      <div>
                        {{ columns[colIndex].subLabel | translate }}
                      </div>
                    </div>
                  </div>
                }
                @if (!columns[colIndex].subLabel) {
                  <div>
                    {{ columns[colIndex].label | translate }}
                  </div>
                }
              </th>
              <td
                mat-cell
                *matCellDef="let row"
                [class]="{
                  'mat-column-number': colIndex > 0,
                }"
              >
                @if (columns[colIndex].type === 'number') {
                  <div>
                    {{ row[column] | number: columns[colIndex].format }}
                  </div>
                }
                @if (columns[colIndex].type === 'date') {
                  <div>
                    {{ row[column] | date: dateFormat }}
                  </div>
                }
              </td>
            </ng-container>
          }
          <tr mat-header-row *matHeaderRowDef="columnIds()"></tr>
          <tr mat-row *matRowDef="let row; columns: columnIds()"></tr>
        </table>
      }
    </div>
  </div>
  <agr-notification-empty
    [isEmpty]="!hasData()"
    [emptyTitle]="'no_items' | translate"
    emptyImage="/assets/images/no-items.png"
    class="complete__notification-empty"
  >
  </agr-notification-empty>
</agr-page-toolbar>
